// Mirrors lib/models/brick_type.dart and lib/theme/neon_theme.dart in the
// brick_break Flutter game repo, so the grid editor preview matches what
// actually renders in-game (see lib/components/brick.dart for the render
// rules this is ported from).

export const BRICK_TYPES = [
  { code: 0, key: "empty", label: "Empty" },
  { code: 1, key: "normal", label: "Normal" },
  { code: 2, key: "permanent", label: "Permanent" },
  { code: 3, key: "multiHit", label: "Multi-hit (3)" },
  { code: 4, key: "explosive", label: "Explosive" },
];

// NeonTheme.brickRowColors
const BRICK_ROW_COLORS = [
  "#00FFF5", // cyan
  "#FF00EA", // magenta
  "#F5FF00", // yellow
  "#39FF14", // green
  "#FF7A00", // orange
  "#FF2E9A", // pink
  "#2E6BFF", // blue
];

const PERMANENT_COLOR = "#3A4066"; // NeonTheme.permanentBrick
const EXPLOSIVE_COLOR = "#FF7A00"; // NeonTheme.orange

/**
 * Fill color for a brick at (row, code), matching Brick._fillColor() in
 * lib/components/brick.dart. `normal` and `multiHit` cycle by row like the
 * game; `permanent` and `explosive` use their own fixed colors regardless
 * of row.
 */
export function colorForCell(row, code) {
  switch (code) {
    case 2:
      return PERMANENT_COLOR;
    case 4:
      return EXPLOSIVE_COLOR;
    case 1:
    case 3:
      return BRICK_ROW_COLORS[row % BRICK_ROW_COLORS.length];
    default:
      return null; // empty - render as a blank cell
  }
}
